import React from "react";
import { Table, Modal, Icon, Button, Tag } from "antd";
import {
  BusinessPartnerType,
  StatusType,
  DuplicateBPCheckPayloadType,
  TaxNumberType,
} from "../types";
import { withRouter } from "react-router-dom";
import { History } from "history";
import { PaginationInfoType } from "../../ChangeLog/types";

interface DuplicateBPProps {
  businessPartnerName: string;
  duplicateBPs: BusinessPartnerType[] | null;
  history: History;
  statuses: StatusType[] | null;
  duplicateBPPagination: PaginationInfoType;
  close: () => any;
  setSelectedBP: (selectedBP: BusinessPartnerType) => any;
  copyBP: (selectedBP: BusinessPartnerType) => any;
  setModeToUpdate: () => any;
  checkDubplicateOf: (payload: DuplicateBPCheckPayloadType) => any;
}
interface DuplicateBPState {
  selectedDuplicate: number;
}

class DuplicateBusinessPartners extends React.Component<
  DuplicateBPProps,
  DuplicateBPState
> {
  constructor(props) {
    super(props);
    this.state = {
      selectedDuplicate: props.duplicateBPs[0].bpId,
    };
  }
  componentDidMount() {}

  setSelectedBP = () => {
    const { selectedDuplicate } = this.state;
    this.props.setSelectedBP(
      this.props.duplicateBPs.find((item) => item.bpId === selectedDuplicate)
    );
    this.props.history.push(`/business-partner-details/${selectedDuplicate}`);
    this.props.close();
    this.props.setModeToUpdate();
  };
  copyBP = () => {
    const record = this.props.duplicateBPs.find(
      (item) => item.bpId === this.state.selectedDuplicate
    );
    this.props.copyBP(record);
    this.props.close();
  };
  handleTableChange = (pagination) => {
    const { duplicateBPPagination: paginationInfo } = this.props;
    if (
      pagination.current !== paginationInfo.currentPage ||
      pagination.pageSize !== paginationInfo.pageSize
    ) {
      // pagination occured
      const payload = {
        sortBy: "",
        isSortAscending: true,
        page: pagination.current,
        pageSize: pagination.pageSize,
        genericSearch: this.props.businessPartnerName,
        searchData: [],
      };
      this.props.checkDubplicateOf(payload);
    }
  };
  render() {
    const {
      duplicateBPs,
      statuses,
      duplicateBPPagination: paginationInfo,
    } = this.props;

    const columns = [
      {
        title: "BP ID",
        dataIndex: "bpId",
        key: "bpId",
        width: 70,
      },
      {
        title: "BP Name One",
        dataIndex: "bpName",
        key: "bpName",
      },
      {
        title: "BP Name Two",
        dataIndex: "bpName2",
        key: "bpName2",
      },
      {
        title: "City",
        dataIndex: "bpCityRefName",
        key: "bpCityRefName",
      },

      {
        title: "Street 1",
        dataIndex: "bpStreet",
        key: "bpStreet",
      },
      {
        title: "ZIP / Postal",
        dataIndex: "bpPostalcodeRefName",
        key: "bpPostalcodeRefName",
      },
      {
        title: "Status",
        dataIndex: "bpStatus",
        key: "bpStatus",
        render: (text: number, record: BusinessPartnerType) => {
          let color = "";
          switch (text) {
            case 4: {
              color = "blue";
              break;
            }
            case 5: {
              color = "red";
              break;
            }
            case 6: {
              color = "green";
              break;
            }
            case 7: {
              color = "orange";
              break;
            }
            case 8: {
              color = "";
              break;
            }
            default: {
              color = "";
              break;
            }
          }

          return (
            <>
              <Tag color={color}>{record.bpStatusName}</Tag>
              {record.bpStatus === 7 && record.bpActionName && (
                <div className="action-name">{record.bpActionName}</div>
              )}
            </>
          );
        },
      },
      {
        title: "VIES Number",
        dataIndex: "taxNumber",
        key: "taxNumber",
        render: (tax: TaxNumberType[]) =>
          tax.length > 0 ? tax[0].tnVIESNumber : "",
      },
    ];
    const rowSelection = {
      type: "radio" as "radio",
      onChange: (selectedRowKeys, selectedRows) => {
        this.setState({ selectedDuplicate: selectedRowKeys[0] });
      },
      selectedRowKeys: [this.state.selectedDuplicate],
    };
    return (
      <Modal
        title="Duplicate Businesss Partners found !"
        visible
        width={1100}
        onCancel={this.props.close}
        className="bp-duplicate-modal"
        footer={null}
      >
        <div>
          <p>
            Following matching business partners were found for a search of
            <em>
              <strong> "{this.props.businessPartnerName}"</strong>
            </em>
          </p>
          <Table
            rowSelection={rowSelection}
            columns={columns}
            dataSource={duplicateBPs || []}
            size="small"
            rowKey="bpId"
            onChange={this.handleTableChange}
            className="duplicate-bp-table"
            pagination={{
              total: paginationInfo.totalRecords,
              pageSize: paginationInfo.pageSize,
              current: paginationInfo.currentPage,
              showSizeChanger: true,
              pageSizeOptions: ["15", "30", "50", "100"],

              showTotal: (total, range) =>
                `${range[0]}-${range[1]} of ${total} Business Partners`,
              // hideOnSinglePage: true
            }}
          />
        </div>
        <div className="actions">
          <Button icon="close" onClick={this.props.close}>
            Cancel
          </Button>
          <Button
            icon="copy"
            type="primary"
            disabled={duplicateBPs.length === 0}
            onClick={this.copyBP}
          >
            Copy
          </Button>
          <Button
            icon="edit"
            type="primary"
            disabled={duplicateBPs.length === 0}
            onClick={this.setSelectedBP}
          >
            Edit
          </Button>
        </div>
      </Modal>
    );
  }
}

export default withRouter(DuplicateBusinessPartners);
